export const extractCoordinatesFromGoogleMapsLink = (url) => {
  if (!url || typeof url !== 'string') {
    return { lat: '', lng: '' };
  }

  try {
    // Decodifica a URL para lidar com caracteres codificados como %2C
    const decodedUrl = decodeURIComponent(url);
    
    // Padrões para extrair coordenadas de diferentes formatos do Google Maps
    const patterns = [
      // Formato: ?q=-19.954700,-43.967182
      /[?&]q=(-?\d+\.?\d*),(-?\d+\.?\d*)/,
      
      // Formato: ?q=-19.88457489013672%2C-43.9057502746582 (já decodificado)
      /[?&]q=(-?\d+\.?\d*),(-?\d+\.?\d*)/,
      
      // Formato: /@-19.954700,-43.967182,17z
      /@(-?\d+\.?\d*),(-?\d+\.?\d*),\d+z/,
      
      // Formato: /place/Nome/@-19.954700,-43.967182,17z
      /place\/[^@]*@(-?\d+\.?\d*),(-?\d+\.?\d*),\d+z/,
      
      // Formato: ?ll=-19.954700,-43.967182
      /[?&]ll=(-?\d+\.?\d*),(-?\d+\.?\d*)/,
      
      // Formato: &center=-19.954700,-43.967182
      /[?&]center=(-?\d+\.?\d*),(-?\d+\.?\d*)/,
      
      // Formato mais genérico para coordenadas separadas por vírgula
      /(-?\d+\.?\d*),(-?\d+\.?\d*)/
    ];

    // Tenta cada padrão até encontrar uma correspondência
    for (const pattern of patterns) {
      const match = decodedUrl.match(pattern);
      if (match && match[1] && match[2]) {
        const lat = parseFloat(match[1]);
        const lng = parseFloat(match[2]);
        
        // Valida se as coordenadas estão dentro de faixas válidas
        if (isValidLatitude(lat) && isValidLongitude(lng)) {
          return {
            lat: lat.toString(),
            lng: lng.toString()
          };
        }
      }
    }

    // Se nenhum padrão funcionou, retorna coordenadas vazias
    return { lat: '', lng: '' };
    
  } catch (error) {
    console.error('Erro ao extrair coordenadas:', error);
    return { lat: '', lng: '' };
  }
};

// Funções auxiliares para validação
const isValidLatitude = (lat) => {
  return !isNaN(lat) && lat >= -90 && lat <= 90;
};

const isValidLongitude = (lng) => {
  return !isNaN(lng) && lng >= -180 && lng <= 180;
};
